import axios from 'axios'
import Message from './feedbackMessage'
import store from '@/store'
import router from '@/router'
import { isNavigationFailure } from 'vue-router'

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

let sessionExpiry = null

function expireSession(config = {}) {
  const path = String(config.url || '').split(/[?#]/)[0]
    .replace(/^https?:\/\/[^/]+/, '').replace(/^\/api(?=\/)/, '')
  // Wrong credentials are a form error, not expiry of the current session.
  if (path === '/auth/login' || path === '/auth/register') return Promise.resolve()
  const token = store.state.user.token
  const sentToken = config.headers?.Authorization || config.headers?.authorization
  if (sentToken && sentToken !== `Bearer ${token}`) return Promise.resolve()
  if (sessionExpiry) return sessionExpiry
  if (!token) return Promise.resolve()
  sessionExpiry = Promise.resolve()
    .then(() => {
      if (store.state.user.token === token) return store.dispatch('user/logout')
    })
    .then(() => {
      if (!store.state.user.token && router.currentRoute.path !== '/login') return router.replace('/login')
    })
    .catch(error => {
      // Expiry must preserve the original API error, never leak a navigation rejection.
      if (!isNavigationFailure(error)) console.error('登录页跳转失败', error)
    })
    .finally(() => { sessionExpiry = null })
  return sessionExpiry
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = store.state.user.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  async response => {
    const res = response.data
    if (res.code !== 200) {
      if (!response.config?.silent) Message.error(res.message || '请求失败')
      if (res.code === 401) await expireSession(response.config)
      const error = new Error(res.message)
      // Preserve only the business code, so a caller can distinguish a definite rejection
      // from an unknown network outcome without retaining response payloads or credentials.
      error.businessCode = res.code
      return Promise.reject(error)
    }
    return res
  },
  async error => {
    if (error.response && error.response.status === 401) {
      await expireSession(error.config)
    }
    if (!error.config?.silent) {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service
